import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Sidebar = styled.aside<{ isOpen?: boolean }>`
  z-index: 9;
  position: relative;
  border-radius: 0 8px 0 0;
  overflow: hidden;
  box-shadow: none;
  background-color: ${(props) => props.theme.colors['neutral-0']};
  height: calc(100% - 20px);
  margin-top: 20px;
  transition: max-width 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
  width: 100%;
  max-width: ${(props) => (props.isOpen ? '240px' : '56px')};
  border-right: 1px solid hsla(0, 0%, 0%, 0.08);

  ${media.mobile} {
    display: none;
  }
`;

export const SidebarLink = styled(Link)<{ $isSelected?: boolean }>`
  width: calc(100% - 4px);
  height: 48px;
  margin: 2px 8px;
  border-radius: 8px;
  font-size: 14px;
  white-space: pre;
  transition: all 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
  font-weight: ${(props) => (props.$isSelected ? '600' : 'normal')};
  background-color: ${(props) =>
    props.$isSelected ? props.theme.colors['secondary-20'] : 'transparent'};
  ${(props) => props.$isSelected && `border-left: 3px solid ${props.theme.colors['primary-60']};`}
  color: ${(props) =>
    props.$isSelected ? props.theme.colors['primary-60'] : props.theme.colors['neutral-100']};
  svg {
    margin: 0 20px;
    width: 20px;
  }
  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-20']};
    color: ${(props) => props.theme.colors['primary-60']};
  }
  &:active {
    background-color: ${(props) => props.theme.colors['secondary-20']};
    color: ${(props) => props.theme.colors['primary-60']};
  }
`;

export const SidebarExpandButton = styled.button<{ isOpen?: boolean }>`
  width: 100%;
  height: 48px;
  cursor: pointer;
  border: 0;
  background-color: transparent;
  color: ${(props) => props.theme.colors['neutral-100']};
  transition: all 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
  justify-content: end;
  svg {
    transition: all 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
    margin: 0 20px;
    width: 16px;
    transform: ${(props) => (props.isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
  }
  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-20']};
    color: ${(props) => props.theme.colors['primary-60']};
  }
`;
